module.exports = __webpack_public_path__ + "static/Group_6261_2x-bad2a1c17df43524bae049f4613251dd.png";